<div class="item-meta">
  <h2 class="main-heading">Choose a color</h2>
</div>
<github-picker id="colorPicker" [control]="githubControl" (click)="openCloseColor(githubControl)">
</github-picker>
